import React, { useRef, useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import { Box, Typography } from '@mui/material';
import { Growth } from '@/components/analytics/common/Growth.jsx';
import { Bar, ReferenceLine, Cell } from 'recharts';
import { getFillColor } from '@/components/analytics/common/BarChartWithTrend.jsx';
import { StatsSparklineChart } from '@/components/device/details/StatsSparklineChart.jsx';
import { Palette } from '@/themes/themeOverrides/Palette';

const getPath = (x, y, width, height) => {
    const radius = 2;
    return `M${x},${y + height}
            L${x},${y + radius}
            Q${x},${y} ${x + radius},${y}
            L${x + width - radius},${y}
            Q${x + width},${y} ${x + width},${y + radius}
            L${x + width},${y + height}
            Z`;
};

export const RoundedTopBar = props => {
    const { fill, x, y, width, height } = props;

    if (height <= 0) {
        return null;
    }

    return <path d={getPath(x, y, width, height)} stroke='none' fill={fill} />;
};

const TransactionsStatsContent = ({ transactionStats, transactionsGrowth, chartData, avgTransactions, theme, barColorThresholds }) => {
    const translate = useTranslate();
    const chartRef = useRef();
    const [y1, setY1] = useState(null);
    useEffect(() => {
        if (chartRef.current) {
            const refLine = chartRef.current.querySelector('.recharts-reference-line-line');
            if (refLine) {
                setY1(refLine.getAttribute('y1'));
            }
        }
    }, [chartData, avgTransactions, theme, barColorThresholds, transactionStats]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '29px' }}>
                <Typography variant='h3'>{transactionStats?.transactionsCount}</Typography>
                <Growth value={transactionsGrowth} />
            </Box>
            <Box ref={chartRef} sx={{ position: 'relative', display: 'flex', flexWrap: 'nowrap', alignItems: 'flex-start', gap: '16px' }}>
                <StatsSparklineChart data={chartData} dataKey='transactionsCount'>
                    <Bar dataKey='transactionsCount' fill='#8884d8' radius={2} background={<RoundedTopBar />}>
                        {chartData.map(entry => (
                            <Cell
                                key={entry.periodStart?.date ?? entry.periodEnd?.date}
                                fill={getFillColor(avgTransactions, entry.transactionsCount, theme, barColorThresholds)}
                            />
                        ))}
                    </Bar>
                    <ReferenceLine y={avgTransactions} stroke={Palette.white} strokeWidth={2} />
                </StatsSparklineChart>
                {transactionStats?.transactionsCount > 0 && (
                    <Typography variant='caption' fontSize={10} fontWeight={700} sx={y1 ? { marginTop: `calc(${y1}px - 8px)` } : undefined}>
                        {translate('resources.device.labels.average')}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default TransactionsStatsContent;
